module.exports = __webpack_public_path__ + "static/media/gall_reply.f50fbf2a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gall_reply.gif
// module id = 782
// module chunks = 0